/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Preferredlanguage1Inputs */

const en__field_preferredlanguage1 = /** @type {(inputs: _Field_Preferredlanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred Language`)
};

const de__field_preferredlanguage1 = /** @type {(inputs: _Field_Preferredlanguage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wunschsprache`)
};

/**
* | output |
* | --- |
* | "Preferred Language" |
*
* @param {_Field_Preferredlanguage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_preferredlanguage1 = /** @type {((inputs?: _Field_Preferredlanguage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Preferredlanguage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_preferredlanguage1(inputs)
	return de__field_preferredlanguage1(inputs)
});
export { _field_preferredlanguage1 as "_field_preferredLanguage" }